import React from 'react';
import { ApiServerUrl } from '../../config.json';
import Typography from '@material-ui/core/Typography';
import join from 'url-join';
const KnowledgeRecord = ({ title, description, link, name }) => {
    return (
        <>
            <h4 style={{ margin: '30px 20px 30px', overflowWrap: 'break-word', maxWidth: '100%' }}>{title}</h4>
            {description ? (
                <h4 style={{ margin: '30px 20px 30px', overflowWrap: 'break-word', maxWidth: '100%' }}>
                    {description}
                </h4>
            ) : null}

            <h4 style={{ margin: '30px 20px 30px', overflowWrap: 'break-word', maxWidth: '100%' }}>
                {link && name ? (
                    <a
                        href={join(ApiServerUrl, '/file/formOrKnowledge?path=', link, '&fileName=', name)}
                        target="_blank"
                    >
                        {name || link}{' '}
                    </a>
                ) : (
                    <a
                        href={link?.toString().startsWith('http') ? link : join('//' + link)}
                        target="_blank"
                        style={{ textDecoration: 'none', display: 'block' }}
                    >
                        {link}
                    </a>
                )}
            </h4>
            <hr style={{ border: 'solid 1px #000000' }}></hr>
        </>
    );
};

export default KnowledgeRecord;
